module.exports = __webpack_public_path__ + "img/streak2.5edbc9b5.png";